var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_864_240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.4444 0C50.3629 0 64.8887 14.5257 64.8887 32.4443C64.8887 50.3628 50.3629 64.8891 32.4444 64.8891C14.5259 64.8891 -0.000442505 50.3628 -0.000442505 32.4443C0.0197601 14.5341 14.5336 0.0201985 32.4444 0ZM32.4444 61.6443C48.5712 61.6443 61.6444 48.571 61.6444 32.4443C61.6444 16.3175 48.5712 3.24425 32.4444 3.24425C16.3176 3.24425 3.2444 16.3175 3.2444 32.4443C3.26282 48.5633 16.3254 61.6259 32.4444 61.6443Z",
    fill: "#B69D74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2426 19.8679C36.9175 19.278 37.9423 19.3469 38.5322 20.0212C39.1215 20.696 39.0526 21.7208 38.3783 22.3107L26.7962 32.4445L38.3789 42.5788C39.0538 43.1687 39.1221 44.1935 38.5328 44.8678C37.9429 45.5427 36.9181 45.6116 36.2432 45.0217L23.2656 33.6659C22.9134 33.3582 22.7114 32.9126 22.7114 32.4445C22.7114 31.9763 22.9134 31.5314 23.2656 31.2231L36.2426 19.8679Z",
    fill: "#B69D74"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_864_240"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64.8889,
    height: 64.8889,
    fill: "white",
    transform: "matrix(-1 0 0 1 64.8887 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/Left Arrow.ac632f246a391840b2db1eb99cf418cb.svg";
export { ForwardRef as ReactComponent };